/**
 * Which hold stopped Finalize (Park Lane Periodontist, invoice #102678706,
 * 10/28). The server answers REVIEW_REQUIRED for two different reasons — a
 * device tested that wasn't on the job, or devices the tech added that the
 * office hasn't OK'd — and says which one in `gate`. The prompt names the
 * right thing instead of always saying "out-of-scope tests".
 */
export interface ReviewPrompt {
    gate: "out_of_scope" | "tech_added_devices";
    title: string;
    /** Plain device names, e.g. '1" Watts 909 (SN 12345)'. */
    devices: string[];
}

export function reviewPromptFromBody(body: Record<string, unknown> | null | undefined): ReviewPrompt {
    const rawDevices = Array.isArray(body?.devices) ? (body!.devices as unknown[]) : [];
    const devices = rawDevices
        .map((d) =>
            typeof d === "string"
                ? d
                : d && typeof d === "object" && typeof (d as { device?: unknown }).device === "string"
                  ? (d as { device: string }).device
                  : null,
        )
        .filter((d): d is string => !!d);
    const gate =
        body?.gate === "tech_added_devices" || (body?.gate !== "out_of_scope" && devices.length > 0)
            ? "tech_added_devices"
            : "out_of_scope";
    return {
        gate,
        title: typeof body?.reviewItemTitle === "string" ? body.reviewItemTitle : "",
        devices,
    };
}
